export default __webpack_public_path__ + "fdb4a7ffbc4af0768dbd3d35bcc550b1.otf";